/* eslint-disable react/prop-types */
"use client";

import React from "react";
import { useNavigate } from "react-router-dom";
import EventCard from "../events/EventCard";
import { toApiAbsoluteUrl } from "../../utils/ws";

function normalizeEventContext(event) {
  if (!event || typeof event !== "object") return null;
  const eventId = Number(event?.id || event?.event_id || 0);
  if (!eventId) return null;
  return {
    id: eventId,
    name: String(event?.name || "").trim(),
    type: String(event?.type || "event").trim() || "event",
    status: String(event?.status || "active").trim() || "active",
    date_time: event?.date_time || null,
    event_format: event?.event_format ?? null,
    host_format: event?.host_format ?? null,
    badge_label: event?.badge_label || null,
    icon_image_url: toApiAbsoluteUrl(event?.icon_image_url || event?.iconImageUrl),
    pricing_model: String(event?.pricing_model || "free").trim() || "free",
    join_by_request: Boolean(event?.join_by_request),
    min_vault_level: Number(event?.min_vault_level) || 0,
    is_verified: Boolean(event?.is_verified),
    is_validated: event?.is_validated !== false,
    public_path: String(event?.public_path || "").trim() || null,
  };
}

export default function DirectChatEventContextNotice({
  event,
  title,
  overlay = false,
}) {
  const navigate = useNavigate();
  const normalizedEvent = normalizeEventContext(event);

  if (!normalizedEvent) return null;

  const canOpenEvent = Boolean(normalizedEvent.public_path);
  const cardNode = (
    <EventCard
      title={normalizedEvent.name}
      badgeLabel={normalizedEvent.badge_label}
      iconImageUrl={normalizedEvent.icon_image_url}
      datetime={normalizedEvent.date_time}
      status={normalizedEvent.status}
      type={normalizedEvent.type}
      isOnline={Number(normalizedEvent.event_format) === 0}
      isPersonal={Number(normalizedEvent.host_format) === 0}
      isPaid={normalizedEvent.pricing_model !== "free"}
      isByRequest={normalizedEvent.join_by_request}
      minVaultLevel={normalizedEvent.min_vault_level}
      isVerified={normalizedEvent.is_verified}
      isValidated={normalizedEvent.is_validated}
      showFavouriteButton={false}
      suppressStatusOverlay
      cardClassName="bg-white/10"
      searchListLayout
    />
  );

  const content = canOpenEvent ? (
    <button
      type="button"
      onClick={(eventObj) => {
        eventObj.preventDefault();
        eventObj.stopPropagation();
        navigate(normalizedEvent.public_path);
      }}
      className="w-full text-left"
    >
      {cardNode}
    </button>
  ) : (
    cardNode
  );

  return (
    <div
      className={`w-full text-white ${
        overlay ? "rounded-[16px] shadow-[0_8px_30px_rgba(0,0,0,0.28)]" : ""
      }`}
    >
      {title ? (
        <p className="mb-2 text-center text-[13px] font-semibold leading-[19px] text-white/92">
          {title}
        </p>
      ) : null}
      {content}
    </div>
  );
}
